import {
    Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/privatetel';

@Module({ namespaced: true })
export default class extends VuexModule {
    @Action
    async list(params: any) {
        return api.list(params);
    }

    @Action
    async phones(params: any) {
        return api.phones(params)
    }

    @Action
    async phoneadd(params: any) {
        return api.phoneadd(params)
    }

    @Action
    async phoneedit(params: any) {
        return api.phoneedit(params)
    }

    @Action
    async phonedetail(params: any) {
        return api.phonedetail(params)
    }

    @Action
    async phonedelete(params: any) {
        return api.phonedelete(params)
    }
}
